import { NgModule } from '@angular/core';
import { OrderByPipe } from '../order-by.pipe';
import { SafePipe } from '../safe.pipe';
import { KnBrRemoveBaseSiteIdPipe } from './kn-br-remove-base-site-id.pipe';
import { RemoveLeadingZerosPipe } from './remove-leading-zeros.pipe';
import { RemoveUnderscorePipe } from '../remove_undescore.pipe';

@NgModule({
    imports: [RemoveLeadingZerosPipe, SafePipe, OrderByPipe, KnBrRemoveBaseSiteIdPipe, RemoveUnderscorePipe],
    exports: [RemoveLeadingZerosPipe, SafePipe, OrderByPipe, KnBrRemoveBaseSiteIdPipe, RemoveUnderscorePipe],
})
export class KnBrCustomPipesModule {}
